export default {
    titleEvents: "Veranstaltungen filtern",
    titleAppointments: "Termine filtern",
    freeText: "Suche",
    freeTextPlaceholder: "Name / Ort / Angebotsnummer / Teaser / Referierende",
    freeTextPlaceholderAppointments: "Name / Ort / Teaser / Referierende",
    dateRange: "Zeitraum",
    dateRangeFrom: "Ab frühestens",
    dateRangeTo: "Bis spätestens",
    categories: "Nach Kategorien filtern",
    showAllCategories: "...",
    forceAllCategories: "Alle Kategorien müsen enthalten sein",
    forceAllEventCategories: "Nur Veranstaltungen mit allen ausgewählten Kategorien anzeigen",
    forceAllAppointmentCategories: "Nur Termine mit allen ausgewählten Kategorien anzeigen",
    eventType: "Veranstaltungsart",
    allTypes: "Alle",
}
